export const CampaignFormTabs = {
    CAMPAIGN_FORM_INFO: 'campaign-info',
    EVENTS: 'events',
    SEND_NOTIFICATIONS: 'send-notifications',
    NOTIFICATIONS: 'notifications',
}
